import React from "react";
import styles from "./PriceComparison.module.scss";
import { useI18n } from "@wojo/localization";

export type PriceComparisonProps = {
    fullPrice: number | string;
    salePrice?: number | string | null;
};
export const PriceComparison: React.FC<PriceComparisonProps> = ({
    fullPrice,
    salePrice,
}) => {
    const { global } = useI18n("global");
    const hasValidSalePrice = salePrice || salePrice === 0;
    if (!hasValidSalePrice || fullPrice === salePrice) {
        return <span>{fullPrice}</span>;
    }

    return (
        <span className={styles.price}>
            <span style={{ textDecoration: "line-through" }}>
                <span className="visually-hidden">
                    ({global.a11y.deleted.l()})
                </span>
                {fullPrice}
            </span>{" "}
            <span
                style={{
                    color: "var(--s-color-promo-price-standard)",
                    fontWeight: "bolder",
                }}
            >
                <span className="visually-hidden">
                    ({global.a11y.inserted.l()})
                </span>
                {salePrice}
            </span>
        </span>
    );
};
